import { SignUp as ClerkSignUp } from '@clerk/clerk-react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const SignUp = () => {
  const { loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-hero">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary mb-4 mx-auto"></div>
          <p className="text-primary animate-pulse">Preparing authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-2xl shadow-lg p-8 border border-border/50">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-foreground mb-2">Create Your Account</h1>
            <p className="text-muted-foreground">Join Founder Labs Ideas to start organizing your startup ideas</p>
          </div>

          <div className="space-y-4">
            <ClerkSignUp
              path="/sign-up"
              routing="path"
              signInUrl="/sign-in"
              afterSignUpUrl="/onboarding"
              appearance={{
                elements: {
                  card: 'bg-card border-none shadow-none',
                  headerTitle: 'text-foreground',
                  headerSubtitle: 'text-muted-foreground',
                  formButtonPrimary: 'bg-primary hover:bg-primary/90 text-primary-foreground',
                  footerActionLink: 'text-primary hover:text-primary/80',
                },
              }}
            />

            <div className="text-center text-sm text-muted-foreground mt-4">
              <p>Already have an account?{' '}
                <Button
                  variant="link"
                  className="p-0 h-auto text-primary hover:text-primary/80"
                  onClick={() => navigate('/sign-in')}
                >
                  Sign in
                </Button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;